import { getGroupListAPI } from "@/apis/admin-api"
import { create } from "zustand"
import { createListStore } from "../create-list-store-util"

export const groupStore = create(createListStore(getGroupListAPI))
